
import React, { useEffect, useState } from 'react';
import axios from "../lib/axios";
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { API_BASE_URL } from '../config';
import { useLoader } from "../contexts/LoaderContext";
import JourneyHeader from "@/components/JourneyHeader";

const AdditionalLoanBank = () => {
  const navigate = useNavigate();
  const { loading, setLoading } = useLoader();

  const handleNext = () => {
    setLoading(true);
    axios
      .post(`${API_BASE_URL}/api/is_enhanced_offer_check_success/`, {})
      .then((res) => {
        console.log("Backend response:", res.data);
        if(res.status === 200 && res.data.is_enhanced_offer_check_success === true){
          navigate('/loan-offer-congrats'); // Navigate to the next step
        } else {
          navigate('/loan-offer-unable'); // Navigate to the unable to proceed page
        }
      })
      .catch((err) => console.error("Fetch error:", err))
      .finally(() => {
        setLoading(false);
      });
  };

  const handleGoBack = () => {
    navigate(-1); // Go back to previous page
  };

  return loading ? (<p>Loading...</p>):
  (
    <div className="min-h-screen bg-intellend-white">
      {/* Header with logo */}
      <JourneyHeader />

      {/* Main content */}
      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white shadow-md rounded-lg p-6 mb-6 text-center">
          <h2 className="text-2xl font-bold text-intellend-green mb-6">Additional Loan Eligibility</h2>
          
          <div className="my-6">
            <p className="text-lg text-gray-700 mb-4">
              Thanks for checking for additional loan amount. We would need to check your bank account details to assess your eligibility better.
            </p>
            <p className="text-md text-gray-600">
              Please click next if you consent or go back to the previous screen.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <Button 
              type="button"
              variant="outline"
              onClick={handleGoBack}
              className="w-full sm:w-auto order-2 sm:order-1"
            >
              Go Back
            </Button>
            <Button 
              onClick={handleNext}
              className="bg-intellend-green hover:bg-intellend-green/90 w-full sm:w-auto order-1 sm:order-2"
            >
              Next
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdditionalLoanBank;
